<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Spinner from "../components/spinner.svelte";
    import Modal from "../components/modal.svelte";
    import DataTable from "../../components/data-table.svelte";
    import { AuthUser } from "../../store.js";
    import Button from "../components/button.svelte";
    import AddUser from "./permissionsAddUser.svelte";

    export let pageTitle = "";
    export let schoolId = $AuthUser.schoolId;
    export let embedded = false;

    let users = [];
    let staffs = [];
    let StaffSelected;
    let StaffAnswer = "";
    let isPageLoading;
    let isRemoveButtonLoading=[];
    let showAddUserModal = false;
    let selectComponent;
    let isAddButtonLoading = false;    
    let order = [[3, "asc"]];
    let showSuccessMessage = false;
    let successMessage="";

    if (!embedded) {
        pageTitle = "Permissions | Wavenet Nimbus";
    }

    onMount(async () => {
        isPageLoading = true;     
        await getSchoolStaff(schoolId);
        await getUserPermission(schoolId);
        isPageLoading = false;
      //  StaffSelected = selectComponent.value;
    });
 
    const getSchoolStaff = async (schoolId) => {
        isPageLoading = true;
        let resp = await wrappedFetch(
            "/api/account/GetSchoolStaff?SchoolId=" + schoolId,
            { method: "get" }
        );
        staffs = await resp.json();
        isPageLoading = false;
        return staffs;
    };

    const getUserPermission = async (schoolId) => {
        isPageLoading = true;
        let resp = await wrappedFetch(
            "/api/account/GetSchoolUserPermissions?SchoolId=" + schoolId,
            { method: "get" }
        );
        users = await resp.json();
        isPageLoading = false;
        return users;
    };

    let SelectedUser = [];
    const removeUserPermission = async (user) => {
       // showDeactivitionModal = true;
        SelectedUser = user;
    };

    const ConfirmRemoveUserPermission = async (user,i) => {
        //isButtonLoading = true;
        SelectedUser = user;
        let resp = await wrappedFetch(
            `/api/account/UpdateSchoolUserPermission?AssocId=${SelectedUser.assocId}&CatAssocRef=-1&invite=${SelectedUser.inviteId}`,
            { method: "post" }
        );
        let result = await resp.json();
        if (result === 0) getUserPermission(schoolId);
        isRemoveButtonLoading[i] = false;
        isRemoveButtonLoading =[...isRemoveButtonLoading]
      //  showDeactivitionModal = false;
        return result;
    };
    const addUserPermission = async () => {
       
        isAddButtonLoading = true;
        let result = await wrappedFetch(
            `/api/account/UpdateSchoolUserPermission?AssocId=${StaffSelected.assocId}&CatAssocRef=1&pid=${StaffSelected.personID}`,
            { method: "post" }
        ).then(r => resp.json()).catch(()=> isPageLoading = false)
      
        if (result == 0) getUserPermission(schoolId);
        StaffSelected = null;
        isAddButtonLoading = false;
        return result;
    };

    const handleReset = async () => {
        showDeactivitionModal = false;
    };

    

    document.addEventListener('click', function (event) {
            //ignoreSync(getSelectedUser(parseInt(event.target.getAttribute('data-id'))));

        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        if (!event.target.matches('.RemoveUserBtn')) return;
        let str = event.target.getAttribute('data');
        const myArr = str.split("-");
        isRemoveButtonLoading[myArr[1]] = true;
        u = users.find(x => x.personId === (parseInt(myArr[0])));
      //  ConfirmRemoveUserPermission(u,myArr[1]);
    }, false);


</script>

<svelte:head>
    <title>{pageTitle}</title>
</svelte:head>


{#if isPageLoading}
    <Spinner />
{:else}
   
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">Select user:</div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                    <select
                    bind:this={selectComponent}
                        bind:value={StaffSelected}
                        on:change={() => (StaffAnswer = "")}
                    disabled={staffs.length < 1}                           
                        class="form-control"
                    >
                    <option value="">-- Please select user to add --</option>
                    {#if staffs.length < 1}
                    <option>No user found</option>
                    {:else}                         
                        {#each staffs as staff}
                            <option value={staff}>
                                {staff.staffFirstP}
                                {staff.staffastP} ({staff.staffEmail})
                            </option>
                        {/each}
                        {/if}
                    </select>
                    
                    
                </div>
                <div class="col-6 mt-3 mt-md-0">
                    <Button buttonText={"Add Administrator"} buttonClass={"btn-primary"} confirmButtonStyle={""}  
                    disabled={staffs.length < 1 || !StaffSelected} isConfirm={true} popupTitle={"Confirmation"} popupText={"Are you sure you want to add this user as an admin?"}
                    bind:isLoading={isAddButtonLoading}
                    on:confirmPopup={addUserPermission}
                    />
                    <!-- <button
                        class="btn btn-primary"
                        disabled={staffs.length < 1 || !StaffSelected}
                        on:click={() => showAddConfirmModal=true}
                        >Add Administrator</button> -->
                </div>
                <!-- <div class="col-12 mt-3 mt-md-2">
                    <p>
                        <a
                            href="javascript:;"
                            on:click={() => (showAddUserModal = true)}
                            >User not in the list?</a>
                    </p>
                </div>-->
            
            </div>
        </div>
    </div>
    <hr/>
    <div class="row">
        <div class="col-12">
            <DataTable DataLength={users.length} order={order} message={"There are no users added."}>
                <thead>
                    <tr>
                        <th width="20%">Name</th>
                        <th width="20%">Email Address</th>
                        <th width="20%">Username</th>
                        <th width="20%">Role</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {#each users as user,i}
                        <tr>
                            <td>{user.firstName} {user.lastName}</td>
                            <td>{user.mailAddr}</td>
                            <td>{user.universalID}</td>
                            <td>{user.role || ''}</td>
                            <td> 
                                {#if user.role != "Nominated Contact"}
                                    <span style="display:flex;">
                                        <Button buttonClass={"RemoveUserBtn"} confirmButtonStyle={"color: #2e817d;padding-left: 0px;text-transform: none;"} 
                                            buttonText={`<span class="material-icons" style="cursor:pointer; color:red;">close</span>${user.assocId > 0 ? "Remove" : "Cancel invite"}`} buttonStyle={""}
                                            bind:isLoading={isRemoveButtonLoading[i]}
                                            popupTitle={"Confirmation"}
                                            popupText={user.inviteId ? "Are you sure you want to cancel this user's invite?" : "Are you sure you want to remove this user's permission?"}
                                            isConfirm={true}
                                            dataid={user.personId + "-" + i}
                                            on:confirmPopup={()=>{ isRemoveButtonLoading[i] = true;ConfirmRemoveUserPermission(user,i);}}>
                                            <span class="material-icons" style="cursor:pointer; color:red;margin-top:7px;">close</span>
                                        </Button>
                                    </span>
                                    <!-- <a href="javascript:;" class="centrer-elements" on:click={() => removeUserPermission(user)}><span
                                        class="material-icons"
                                        style="cursor:pointer; color:red">close</span> {user.assocId > 0 ? "Remove" : "Cancel invite"}</a> -->
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </DataTable>
        </div>
    </div>
{/if}
<!-- 
{#if showDeactivitionModal}
<ModalConfirm
    bind:showModal={showDeactivitionModal}
    on:close={handleReset}
    bind:isButtonLoading={isButtonLoading}
    zindex="1052"
    sizeClass="modal-md"
    targetClass="confirm-options"
    on:confirm={ConfirmRemoveUserPermission}
>
    <div slot="header">
        <h4 class="title">Confirmation</h4>
    </div>
    <div slot="content">
      {SelectedUser.inviteId ? "Are you sure you want to cancel this user's invite?" : "Are you sure you want to remove this user's permission?"}  
    </div>
</ModalConfirm>
{/if}

{#if showAddConfirmModal}
<ModalConfirm
    bind:showModal={showAddConfirmModal}
    on:close={()=>showAddConfirmModal=false}
    bind:isButtonLoading={isButtonLoading}
    zindex="1052"
    sizeClass="modal-md"
    targetClass="confirm-options"
    on:confirm={addUserPermission}
>
    <div slot="header">
        <h4 class="title">Confirmation</h4>
    </div>
    <div slot="content">
    Adding this user as administrator will send an email to <b>{StaffSelected.staffEmail}</b>.
    <br><br>
    Would you like to continue?
    </div>
</ModalConfirm>
{/if} -->

{#if showAddUserModal}
    <AddUser bind:showAddUserModal on:userInvited={async (e)=>{if (e.detail.successMessage!="") {showSuccessMessage = true; successMessage=e.detail.successMessage} }}  schoolId={schoolId}/>
{/if}
{#if showSuccessMessage}
    <Modal sizeClass="modal-md" bind:showModal={showSuccessMessage} zindex={"1052"} on:close={async ()=>{await getUserPermission(schoolId); }}>
        <div slot="header"><h4>Success</h4></div>
        <div slot="content">{@html successMessage}</div>
    </Modal>
{/if}


<style>
    .centrer-elements{
        display: flex;
        align-items: center;
        text-decoration: none;
    }
</style>